<div data-target="logout" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" [innerHtml]="heading" tabindex="-1"> </h1>
        <p class="dt-l-article__section__description" [innerHtml]="message"> </p>
        <div class="dt-l-button-group">
          <button type="button" class="dt-c-button primary" routerLink="/cockpit">
            {{ 'OK' | translate }}
          </button>
        </div>
      </section>
    </div>
  </article>
</div>
